import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { Subscription, throwError } from 'rxjs';
import { FieldOption } from '../common/field-option.enum';
import { SharedFormService } from '../services/shared-form.service';

@Component({
  selector: 'app-form-field',
  templateUrl: './form-field.component.html',
  styleUrls: ['./form-field.component.scss']
})
export class FormFieldComponent implements OnInit, OnDestroy, OnChanges {

  @Input() public labelName: string;
  @Input() public controlName: string;
  @Input() public formGroup: FormGroup;
  @Input() public txtSize: number;
  @Input() public typeOfInput: string;
  @Input() public fieldOption: FieldOption;
  @Input() public dataImport: any[]
  @Input() public validationFunc: Function;
  @Input() public errorMessage: string;
  @Input() public triggerError: boolean;
  @Input() public fieldLen: number;
  @Input() public isLogin: boolean = false;
  @Input() public isMEmailRequired: boolean = false;
  @Input() public placeholderName: string;
  @Input() public maxLength: number;

  @Output() valueUpdateParent = new EventEmitter();
  @Output() metLimit = new EventEmitter();
 


  blnShowError: boolean = false;
  txtFieldSize: number = 20;
  blnShowResult: boolean = false;
  fieldType = 'text';
  blnRenderText: boolean = true;
  blnRenderMenu: boolean = false;
  blnShowMenu: boolean = false;
  blnPrimePhone: boolean = false;
  blnFieldGreen: boolean = false;
  blnCheckPassword: boolean = false;
  blnZipCodeMask: boolean = false;
  blnNumLimitMask: boolean = false;
  eventSub:Subscription;

  constructor(private formSvc: SharedFormService) { }


  ngOnInit() {
    this.eventSub = this.formSvc.formStatusEvent.subscribe( (errorKey:string) => {
     
      if (errorKey === this.controlName) {
        this.blnShowError = true;
      }
    });
    if(this.txtSize) {
      this.txtFieldSize = this.txtSize;
    }
    if (this.typeOfInput) {
      this.fieldType = this.typeOfInput;
    }

    if (this.fieldOption) {
      this.blnRenderText = (this.fieldOption === FieldOption.Text);
      this.blnRenderMenu = (this.fieldOption === FieldOption.DropdownState);
      this.blnPrimePhone = (this.fieldOption === FieldOption.PhoneMask);
      this.blnCheckPassword = (this.fieldOption === FieldOption.CheckPassword);
      this.blnShowResult = (this.fieldOption === FieldOption.ShowReadOnly);
      this.blnZipCodeMask = (this.fieldOption === FieldOption.ZipCodeMask);
      this.blnNumLimitMask = (this.fieldOption === FieldOption.NumLimitMask);

     // console.log('Date Widget =>', this.fieldOption === FieldOption.DateWidget, this.controlName);
     // console.log('The Prime Phone =>', this.blnPrimePhone, this.fieldOption, FieldOption.ShowReadOnly, this.controlName);
    }
  }
  ngOnChanges(changes: SimpleChanges) {
    if (this.typeOfInput) {
      this.fieldType = this.typeOfInput;
    }
    // console.log('The changes form => ', changes);
    // console.log("my-email",this.controlName, !this.formGroup.get(this.controlName), !this.formGroup.get(this.controlName).value);
    
    if(changes.isMEmailRequired && !this.formGroup.get(this.controlName).value && this.formGroup.get(this.controlName).touched) {
      this.blnShowError = true;
    } else {
      this.blnShowError = false;
    }
  }
  invalidEmailError:boolean=false;
  ifInvalidEmailErrorGiven=false;
  str:string="invalid Email ";
  
  checkIfValid(): void {
   // console.log(this.labelName)
    if(this.fieldOption === FieldOption.PhoneMask && this.labelName.indexOf('Fax') < 0) {
      const re  = /^\(\d{3}\)[- ]\d{3}[- ]?\d{4}$/g;
      this.blnShowError = !re.test(this.formGroup.get(this.controlName).value);
      
    } //else if (this.labelName.indexOf('Email Address') >= 0) {
      else if (this.labelName==='Email Address') {
     const re =  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;
      // console.log("check if contain error=",!re.test(this.formGroup.get(this.controlName).value));
      // console.log("length>0",this.formGroup.get(this.controlName).value.length>0 && !re.test(this.formGroup.get(this.controlName).value));
      // console.log("Email=",this.formGroup.get(this.controlName).value)
      if(this.formGroup.get(this.controlName).value.length>0 && !re.test(this.formGroup.get(this.controlName).value)){
        // console.log(this.str);
        this.invalidEmailError=true;
        this.ifInvalidEmailErrorGiven=true;
      }
      this.blnShowError = !re.test(this.formGroup.get(this.controlName).value)
      //this.blnShowError = !re.test(this.formGroup.get(this.controlName).value) && (this.formGroup.get(this.controlName).value === null && this.isMEmailRequired)
      //console.log(this.controlName)
    }
    else {
      this.blnShowError = this.formGroup.get(this.controlName).touched &&
      !this.formGroup.get(this.controlName).valid
    }


  }
  toggleMenu(): void {
    this.blnShowMenu = !this.blnShowMenu;
  }
  getCurrentValue(): any {
    return this.controlName && this.formGroup.get(this.controlName).value ? this.formGroup.get(this.controlName).value : '';
  }
  getCurrentControl(): AbstractControl{
    return this.formGroup.get(this.controlName);
  }
  onCheckPassword(event): void {
    if(this.validationFunc) {
      const result = this.validationFunc(event.target.value)
      
      // this.labelName = result.verbiage;
      if(result.firstPasswordField) {
        this.blnShowError = !(result.hasCapital && result.hasOneNumber && result.hasSpecial && result.hasLength);
        this.blnFieldGreen = result.hasCapital && result.hasOneNumber && result.hasSpecial && result.hasLength;
      } else {
        
        this.blnShowError = !(result.hasCapital && result.hasOneNumber && result.hasSpecial && result.hasLength && result.hasPasswordMatch);
        this.blnFieldGreen = result.hasCapital && result.hasOneNumber && result.hasSpecial && result.hasLength && result.hasPasswordMatch;
      }

      this.valueUpdateParent.emit(result);
    }
  }
  nextFocus(event): void {
    this.metLimit.emit(event);
  }
  ngOnDestroy(): void {
    if(this.eventSub) {
      this.eventSub.unsubscribe();
    }
  }

}
